import Navbar from './Navbar';
import Page from './Page';
import Container from './Container';
import SideMenu from './SideMenu';
import Content from './Content';

export default {
  Navbar,
  Page,
  Container,
  SideMenu,
  Content,
};
